import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
  return {
    content: {
      maxWidth: '100%',
      [theme.breakpoints.up('md')]: {
        minWidth: 500,
      },
      [theme.breakpoints.up('lg')]: {
        minWidth: 600,
      },
    },
    paper: {
      padding: theme.spacing(2),
    },
    divider: {
      marginBottom: theme.spacing(1),
    },
    dividerText: {
      marginTop: theme.spacing(1),
    },
    centeredRow: {
      marginBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
    },
    row: {
      marginBottom: theme.spacing(2),
    },
    avatar: {
      width: 100,
      height: 100,
    },
  };
});
